<template>
<div v-for="badgeProject in badgeProjectList" :key="'badgeProject' + badgeProject.id" style="padding-bottom: 1.5rem;">
  <div v-for="badge in badgeProject.badgeList" :key="'badge' + badge.id">
    <div style="margin-bottom: 4px;margin-left:2px;">
      <div style="display: flex;align-items: center;">
        <h4 class="game_title" style="display: inline-block;font-size: 1.3rem;">
          {{ badge.title }}

        </h4>
      </div>
    </div>
    <!--/*  バッジ スイッチを含める */-->
    <section class="badge-all" style="width: 100%; display: flex; flex-direction: column">
      <!--/*   */-->
      <div style="display: flex">
        <!--/*  画像  */-->
        <div style="display: flex; justify-content: center; align-items: flex-start">
          <div class="badge-image-wrapper rounded">
            <img class="badge-image" :src="urls.getBadgeImageURL(badgeProject, badge)" />
          </div>
        </div>
        <!--/*  内容  */-->
        <div style="flex-grow: 1;">
          <div style="min-height:3rem;text-align: left;padding-left:8px;">
            {{ badge.explanation }}
          </div>
          <!--/*
          <div class="pa8" style="color:#999">
            <span> {{ gotRate(badgeProject, badge) }}</span>
            <span> [取得 / 再生数] </span>
          </div>
          */-->
          
          <div style="text-align: right;">
            <div style="display: inline-flex;justify-content: right;align-items: center;">   
              <router-link v-if="badge.publicPage" :to="projectURL(badgeProject, badge)" class="gray-focus">
                {{ badge.publicPage?.title }}
              </router-link>
              <span v-else>
                {{ "プロジェクトNo." + badgeProject.id }}
              </span>
              
              <div style="padding:0 0 0 4px;line-height: 1rem;">
                <UserBlockSmall :dtoUser="badgeProject.user"></UserBlockSmall>
              </div>
            </div>
          </div>
          <div style="text-align: right;">
            <div style="display: inline-flex; justify-content: flex-end" v-if="showDisplaySwitch">
              <div>
                <div v-if="isPublicButtonDisabled(badge)" 
                  style="font-size: small;color: #666; word-break: break-all;text-align: right;line-height: 1rem;"
                >
                  ※非公開ページで取得されたバッジのため公開できません。
                </div>
                <Switch 
                  v-else
                  :textOn="'公開プロフィールに表示する'"
                  :textOff="'公開プロフィールに表示しない'"
                  :isOn="badge.isDisplay"
                  @input="onChange(badge)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>
  </div>
</div>
</template>

<script lang="ts">
import BadgeProjectResp, { RespBadge } from '@/interface/api/BadgeProjectResp';
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import routeState from "@/state/RouteState";
import Switch from '@/component/parts/Switch.vue';
import common from '@/common';
import UserBlockSmall from "@/component/parts/UserBlockSmall.vue";
import { PublicPagePrivacyLevel } from '@/types/PublicPagePrivacyLevel';
import urls from "@/URLs";


@Options({
  components: { Switch, UserBlockSmall },
  props: {
    badgeProjectList: {
      type: Array,
      default: []
    },
    showDisplaySwitch:{
      type:Boolean,
      default:true
    }
  },
  emits: ['onSwitchBadgeDisplay'],  
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly badgeProjectList!: BadgeProjectResp[];
  readonly showDisplaySwitch!: boolean;
  PublicPagePrivacyLevel = PublicPagePrivacyLevel;
  routeState = routeState;
  common = common;
  readonly urls = urls;
  
  projectURL(badgeProject: BadgeProjectResp, badge: RespBadge){
    if(badge.publicPage){
      return urls.getPublicPageURLFrom(badgeProject.user.userName, badge.publicPage?.titleURL)
    }else{
      return null
    }
  }

  isPublicButtonDisabled(badge: RespBadge){
    return !badge.publicPage || badge.publicPage.privacyLevel < PublicPagePrivacyLevel.SEARCHABLE
  }

  // 取得率
  gotRate(badgeProject: BadgeProjectResp, badge: RespBadge) {
    //直接https://forkstyle.com/xxx/yyy のページを開いてバッジを取得した場合、viewCountが更新されないので0もあり得る
    return badge.totalGotUser + " / " + (badge.publicPage?.viewCount || 1)
  }

  onChange(badge: RespBadge){
    this.$emit("onSwitchBadgeDisplay", badge)    
  }  
}
</script>


<style lang="scss" scoped>
.back {
  background-color: #eeeeee;
}

.pa8 {
  padding: 2px 10px;
}

.pa10 {
  padding: 10px;
}

.game_title {
  padding: 8px 0px 2px;
  margin-bottom: 0;
  color: #222222;
}

.badge-all {
  margin-bottom: 8px;
}

.badge-image {
  width: 80px;
  height: 80px;
  padding: 2px;
  user-select: none;
}
.badge-image-wrapper {
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.badge-content-top {
  padding: 0px 8px 0px;
}

.badge-body {
  margin: 0px 8px 8px 8px;
  padding: 8px;
  background-color: white;
}

.rate {
  cursor: pointer;
}
</style>
